export enum PersonStatuses {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Pending = "PENDING",
  Deceased = "DECEASED",
  Unregistered = "UNREGISTERED",
}
